import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const SignsCustomSoftware7 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="signsCustomSoftware" section="worthIt">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="signsCustomSoftware:worthIt" noGroupTitle tag="h3" first />
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="signsCustomSoftware:worthIt.closing" noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default SignsCustomSoftware7;
